import i18n from "@/plugins/vuei18n";

export default {
    ADMIN: 'admin',
    USER: 'user',
    PARTNER: 'partner',
    TRADER: 'trader',
    list: [
        {
            label: i18n.t('user.roles.admin'),
            value: 'admin'
        },
        {
            label: i18n.t('user.roles.user'),
            value: 'user'
        },
        {
            label: i18n.t('user.roles.partner'),
            value: 'partner'
        },
        {
            label: i18n.t('user.roles.trader'),
            value: 'trader'
        }
    ],
    translate(name) {
        return this.list.find(role => role.value === name).label
    }
}
